import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import classNames from 'classnames';
import styles from './styles/CustomsMessagingBody.scss';

import { CustomsMessagingBody_viewer$key } from './__generated__/CustomsMessagingBody_viewer.graphql';

type Props = {
    viewer: CustomsMessagingBody_viewer$key | null;
    currency: string;
    isAuction?: boolean;
    wrapperClass?: string;
    messageClass?: string;
};

const viewerFragment = graphql`
    fragment CustomsMessagingBody_viewer on Viewer {
        dutiesClassification(
            buyerId: $userId
            itemId: $itemId
            shippingAddressId: $shippingAddressId
        ) {
            duties
        }
    }
`;

const CustomsMessagingBody: FC<Props> = ({
    viewer: viewerRef,
    currency,
    isAuction,
    wrapperClass,
    messageClass,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const customsMessage = viewer?.dutiesClassification?.duties || '';
    const showDisclaimer = ['DUTY_EXEMPT', 'NOT_DUTY_EXEMPT'].includes(customsMessage);

    if (!showDisclaimer) {
        return null;
    }

    let legalMessage;

    if (customsMessage === 'NOT_DUTY_EXEMPT') {
        legalMessage = (
            <FormattedMessage
                id="customs.messaging.notExempt"
                defaultMessage="Customs duties and taxes may apply to international purchases. <learnMoreLink>Learn more</learnMoreLink> in our support center."
                values={{
                    learnMoreLink: words => (
                        <Link
                            href="https://support.1stdibs.com/s/article/Customs-Duties-and-Taxes-for-International-Shipments?_ga=2.226635358.256726246.1595260514-1431767277.1560791984"
                            title="customs-messaging-learn-more-link"
                            target="_blank"
                        >
                            {words}
                        </Link>
                    ),
                }}
            />
        );
    } else if (customsMessage === 'DUTY_EXEMPT') {
        const formattedDuties = <FormattedNumber value={0} style="currency" currency={currency} />;
        legalMessage = (
            <FormattedMessage
                id="customs.messaging.Exempt"
                defaultMessage="Estimated Customs and Duties: {formattedDuties}"
                values={{
                    formattedDuties,
                }}
            />
        );
    }

    return (
        <div
            className={classNames(wrapperClass, {
                [styles.detailsDisclaimer]: !wrapperClass,
                [styles.textSizeAuctions]: !wrapperClass && isAuction,
                [styles.textSizePdpCheckout]: !wrapperClass && !isAuction,
            })}
        >
            <p
                key={'customsCode'}
                className={classNames(messageClass, {
                    [styles.detailsDisclaimer]: !messageClass,
                })}
            >
                {legalMessage}
            </p>
        </div>
    );
};

export default CustomsMessagingBody;
